import React from 'react';
import { useTerminology } from '../../hooks/useTerminology';
interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  action?: React.ReactNode;
}

/**
 * Empty states resolve terminology too — they are where a product most often
 * names a concept ("No properties yet"), and a rename that missed them would
 * leave the old vocabulary showing in exactly the moment a person is reading
 * carefully. Plain text passes through unchanged.
 */
export function EmptyState({
  icon,
  title,
  description,
  action
}: EmptyStateProps) {
  const {
    phrase
  } = useTerminology();
  return <div className="flex flex-col items-center justify-center px-6 py-12 text-center" data-id="element-5891" data-mp="14or8d5b9kmsd">
      <div aria-hidden className="flex h-12 w-12 items-center justify-center rounded-full border border-line bg-canvas text-ink-muted" data-id="element-5892" data-mp="19g98jr5gqjca">
        {icon}
      </div>
      <p className="mt-4 text-h4 font-semibold text-ink" data-id="element-5893" data-mp="gz6moenq7bfe">{phrase(title)}</p>
      <p className="mt-1.5 max-w-[46ch] text-body text-ink-muted" data-id="element-5894" data-mp="gx27h0kdmpzt">{phrase(description)}</p>
      {action && <div className="mt-4" data-id="element-5895" data-mp="17qvz4n9u89ts">{action}</div>}
    </div>;
}